import { Skeleton } from "@monorepo-apps/ui/src/components/skeleton";

/**
 * Loading placeholder mirroring the planner layout — milestone rail + the
 * per-workstream task columns — so the page keeps its shape while data loads.
 */
export function PlannerSkeleton({ milestones = 6, cols = 3, rowsPer = 4 }) {
  return (
    <div className="flex flex-col gap-6" aria-hidden>
      {/* milestone rail */}
      <div className="flex flex-col gap-1">
        <Skeleton className="h-2.5 w-48" />
        <div className="flex gap-2.5 pt-1 pb-1.5">
          {Array.from({ length: milestones }).map((_, i) => (
            <div
              key={i}
              className="bg-card border-border flex w-[182px] shrink-0 flex-col gap-2 rounded-xl border border-t-[3px] px-3 py-2.5"
            >
              <div className="flex items-baseline justify-between">
                <Skeleton className="h-3.5 w-8" />
                <Skeleton className="h-2.5 w-10" />
              </div>
              <Skeleton className="h-2.5 w-[80%]" />
              <Skeleton className="h-2.5 w-16" />
              <Skeleton className="h-[5px] w-full rounded" />
              <Skeleton className="h-2 w-20" />
            </div>
          ))}
        </div>
      </div>

      {/* mode toggle */}
      <Skeleton className="h-9 w-44 rounded-lg" />

      {/* task columns */}
      <div className="grid gap-3 lg:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: cols }).map((_, ci) => (
          <section key={ci} className="glow-card-static overflow-hidden rounded-xl">
            <div className="border-border flex flex-col gap-1.5 border-b px-3.5 py-2.5">
              <div className="flex items-center gap-2">
                <Skeleton className="h-3.5 w-8" />
                <Skeleton className="h-3 w-32" />
              </div>
              <Skeleton className="h-[5px] w-full rounded" />
              <Skeleton className="h-2.5 w-24" />
            </div>
            {Array.from({ length: rowsPer }).map((_, ri) => (
              <div
                key={ri}
                className="border-border/60 flex items-start gap-2.5 border-t px-3.5 py-2.5"
              >
                <Skeleton className="mt-1 size-2 rounded-full" />
                <div className="flex flex-1 flex-col gap-1.5">
                  <Skeleton className="h-3 w-[85%]" />
                  <div className="flex gap-1.5">
                    <Skeleton className="h-3.5 w-20" />
                    <Skeleton className="h-3.5 w-16" />
                  </div>
                </div>
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
